import { Login } from '@/components/Login';
// import { Login } from "@yara-dpp/frontend-components.ui.login";

interface LoginPageProps {
  signIn: () => void;
}

const LoginPage = ({ signIn }: LoginPageProps) => {
  const onSingleSignOn = (event: React.MouseEvent) => {
    event.preventDefault();
    signIn();
  };

  return (
    <section className="w-full h-full flex flex-col items-center justify-center bg-yara-background-primary">
      <Login
        singleSignOnClick={onSingleSignOn}
        singleSignOn
      />
    </section>
  );
};

export default LoginPage;
